<template>
  <div class="container-fluid">
    <breadcrumbs class="bg-light text-muted"></breadcrumbs>
    <div class="bg-white rounded">
      <channel-header class="row pt-5 pl-5 pr-5"></channel-header>
      <channel-navigation class="row pt-5 pl-5 pr-5"></channel-navigation>
      <div class="row">
        <div class="col-12">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/common/Breadcrumbs'
  import ChannelHeader from '@/components/administration/channel/common/ChannelHeader'
  import ChannelNavTabs from '@/components/administration/channel/common/ChannelNavTabs'
  import eventBus from '@/services/event-bus/event-bus'
  import {prepareChannel} from '@/components/administration/channel/router-guard-handler'

  export default {
    metaInfo() {
      return {
        title: this.channel.name
      }
    },

    components: {
      'channel-header': ChannelHeader,
      'channel-navigation': ChannelNavTabs,
      'breadcrumbs': Breadcrumbs
    },

    store: {
      channel: 'administration.channelDetail.channel'
    },

    data() {
      return {
        selectedChannelDetail: null
      }
    },

    methods: {
      updateChannel(channel) {
        log.debug('channel-old', this.channel)
        log.debug('channel-new', channel)
        this.channel = channel
      }
    },

    created() {
      eventBus.$on('update-channel', this.updateChannel)
    },

    beforeRouteEnter(to, from, next) {
      prepareChannel(to, next, (vm, channel) => {
        vm.channel = channel
      })
    },

    beforeRouteUpdate(to, from, next) {
      prepareChannel(to, f => f(this), (vm, channel) => {
        vm.channel = channel
      })
      next()
    }
  }
</script>
